import { Signal } from "@lit-labs/signals";
import type { LiveEvent } from "api-contracts/rpc/get-live-events";
import type { SortState } from "ui-components/wow-base-table/types";
import { sortItems } from "ui-components/wow-base-table/sort-utils";
import type { SortEntry } from "ui-components/wow-base-table/sort-types";
import type { IWritableCreatorLiveEventsState } from "./types";

const STATUS_ORDER: Record<string, number> = {
  live: 0,
  scheduled: 1,
  ended: 2,
  cancelled: 3,
};

export class CreatorLiveEventsState implements IWritableCreatorLiveEventsState {
  readonly events = new Signal.State<LiveEvent[]>([]);
  readonly isLoading = new Signal.State<boolean>(false);
  readonly errorMessage = new Signal.State<string>("");
  readonly activeSorts = new Signal.State<SortEntry[]>([]);

  get primarySortState(): SortState {
    const first = this.activeSorts.get()[0];
    if (!first) return { column: null, direction: "none" };
    return { column: first.column, direction: first.direction };
  }

  getSortedItems(items: LiveEvent[]): LiveEvent[] {
    return sortItems(items, this.activeSorts.get(), STATUS_ORDER);
  }
}
